// Priority chip — dot + label. Mockup .priority-badge + .priority-dot.
import type { JobPriority } from "../../../../../../shared/types/production-schedule";

interface Props {
  priority: JobPriority;
}

export function PriorityBadge({ priority }: Props) {
  return (
    <span className="priority-badge">
      <span className={`priority-dot ${priority.toLowerCase()}`} />
      {priority}
    </span>
  );
}
